import React, { createContext, useState } from "react";
import { getById, mapToNamedProperty, NamedProperty } from "sprint-common-web";

import { useDistributorsApi } from "../../api/catalogue-api/distributors/useDistributorsApi";

interface IDistributorsDataContext {
    suggestDistributor(name: string): Promise<Distributor[]>;
    getDistributorById(id: string): Promise<Distributor>;
}

export type Distributor = NamedProperty;

export const DistributorsDataContext = createContext<IDistributorsDataContext>({} as IDistributorsDataContext);

type DistributorsDataProviderProps = React.PropsWithChildren<unknown>;

export const DistributorsDataProvider: React.FunctionComponent<DistributorsDataProviderProps> = ({
    children
}: DistributorsDataProviderProps) => {
    const [distributors, setDistributors] = useState<Distributor[]>([]);

    const { suggestDistributorsByName } = useDistributorsApi();

    const suggestDistributor = async (name: string) => {
        const result = await suggestDistributorsByName({ name });
        const distributorsItems = result.items.map((item) => {
            return mapToNamedProperty(item);
        });

        setDistributors(distributorsItems);

        return distributorsItems;
    };

    const getDistributorById = async (id: string) => {
        return getById(distributors, id);
    };

    return (
        <DistributorsDataContext.Provider value={{ suggestDistributor, getDistributorById }}>
            {children}
        </DistributorsDataContext.Provider>
    );
};
